// NS-753

export const ROLE_FULL_ADMIN = "full_admin";
export const ROLE_POLICY_ADMIN = "policy_admin";
export const ROLE_READ_ONLY = "read_only";

//Role is the dashboard role of a session, as GET /api/auth reports it.
export type Role = typeof ROLE_FULL_ADMIN | typeof ROLE_POLICY_ADMIN | typeof ROLE_READ_ONLY;

//The role sets that menu items and routes declare.
export const ALL_ROLES: readonly Role[] = [ROLE_FULL_ADMIN, ROLE_POLICY_ADMIN, ROLE_READ_ONLY];
export const POLICY_EDITOR_ROLES: readonly Role[] = [ROLE_FULL_ADMIN, ROLE_POLICY_ADMIN];
export const FULL_ADMIN_ROLES: readonly Role[] = [ROLE_FULL_ADMIN];

const ROLE_LABELS: { [key in Role]: string } = {
    [ROLE_FULL_ADMIN]: "Full Admin",
    [ROLE_POLICY_ADMIN]: "Policy Admin",
    [ROLE_READ_ONLY]: "Read-only",
};

function isRole(value: unknown): value is Role {
    return typeof value === "string" && Object.prototype.hasOwnProperty.call(ROLE_LABELS, value);
}

//normalizeRole maps a role value from the server to a known role. An empty or
//unknown value gets the lowest role, so that a missing field never shows more
//than the server allows.
export function normalizeRole(value: unknown): Role {
    return isRole(value) ? value : ROLE_READ_ONLY;
}

export function roleLabel(role: Role): string {
    return ROLE_LABELS[role];
}

//storedRoleLabel labels the role of a stored record, such as a login history
//entry. Records from before RBAC have no role, and an unknown value is shown
//as it is rather than as a role it is not.
export function storedRoleLabel(value: string | undefined): string {
    if (!value) {
        return "—";
    }

    return isRole(value) ? ROLE_LABELS[value] : value;
}
